import { KEY_CODES } from "../../../gearshiftGame/constants";

/**
 * Separated phases for mission five tutorials.
 */

export function buildPhase0(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      trial_duration: newGame.targetLaunchDelay,
      on_load: () => newGame.startPhase0(),
      on_finish: (data) => {
        data.name = "initializeTarget";
        data.driverSpeed = newGame.driverCarSpeed;
        data.distanceToTarget = newGame.driverDistanceToTarget;
        data.trialStart = {
          name: "trialStart",
          driverSpeed: newGame.driverCarSpeed,
          timestamp: jsPsych.data.get().last(2).values()[0].time_elapsed,
        };
      },
    },
  ];
}

export function buildPhase0_1_M5(newGame) {
  return [
    {
      choices: ["KeyZ", "Slash"],
      on_load: () => newGame.startPhase0_1M5(),
      on_finish: (data) => {
        data.name = "choiceCooperation";
        const isCooperating = (data.response_event_code ?? data.response) === "Slash";
        data.cooperating = isCooperating ? 1 : 0;
        if (newGame) newGame.cooperating = data.cooperating;
      },
    },
  ];
}

export function buildPhase0_2_M5(newGame) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => newGame.startPhase0_2M5(),
      on_finish: (data) => {
        data.name = "moveTruckCenter";
      },
    },
  ];
}

export function buildPhase0_3_M5(newGame) {
  return [
    {
      choices: ["KeyS", "KeyD", "KeyF", "KeyK", "KeyL", "Semicolon"],
      on_load: () => newGame.startPhase0_3M5(),
      on_finish: (data) => {
        data.name = "choiceLaneDriver";
        data.userKeyCode = KEY_CODES[data.response_event_code ?? data.response] ?? null;
      },
    },
  ];
}

export function buildPhase0_4_M5(newGame) {
  return [
    {
      choices: ["KeyS", "KeyD", "KeyF", "KeyK", "KeyL", "Semicolon"],
      on_load: () => newGame.startPhase0_4M5(),
      on_finish: (data) => {
        data.name = "proposePartnerLane";
        data.partnerKeyCode = KEY_CODES[data.response_event_code ?? data.response] ?? null;
      },
    },
  ];
}

export function buildPhase0_4B_M5(newGame) {
  return [
    {
      choices: "NO_KEYS",
      trial_duration: 1000,
      on_load: () => {
        const partnerKeyCode = newGame._tutorialPartnerKeyCode;
        newGame.startPhase0_4BM5(partnerKeyCode);
      },
      on_finish: (data) => {
        data.name = "confirmPartnerLane";
      },
    },
  ];
}

export function buildPhase0_5_M5(newGame) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => {
        newGame.startPhase0_5M5(newGame._tutorialLaneCodes || []);
      },
      on_finish: (data) => {
        data.name = "movingIntoLanes";
        data.moveTruckLane = newGame.moveTruckLane;
      },
    },
  ];
}

export function buildPhase0_6_M5(newGame) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => {
        newGame.startPhase0_6M5(newGame._tutorialPhase06LaneCodes || []);
      },
      on_finish: (data) => {
        data.name = "cooperationOutcome";
      },
    },
  ];
}

export function buildPhase7(newGame, jsPsych) {
  return [
    {
      choices: "NO_KEYS",
      on_load: () => newGame.startPhase7(),
      on_finish: (data) => {
        data.name = "driverAtCenter";
        data.driverToCenter = {
          timestamp: jsPsych.data.get().last(2).values()[0].time_elapsed,
          driverSpeed: newGame.driverCarSpeed,
        };
        data.driverSpeed = newGame.driverCarSpeed;
      },
    },
  ];
}
